import { useState, useEffect } from 'react'
import { Navbar } from '@/components/landing/Navbar'
import { Hero } from '@/components/landing/Hero'
import { YardMapPreview } from '@/components/landing/YardMapPreview'
import { OperationShowcase } from '@/components/landing/OperationShowcase'
import { SubscribersPreview } from '@/components/landing/SubscribersPreview'
import { PricingRules } from '@/components/landing/PricingRules'
import { FinancialIntelligence } from '@/components/landing/FinancialIntelligence'
import { IntelligentPayments } from '@/components/landing/IntelligentPayments'
import { PricingFAQ } from '@/components/landing/PricingFAQ'
import { Footer } from '@/components/landing/Footer'
import { DemoDialog } from '@/components/landing/DemoDialog'

export default function Landing() {
  const [demoOpen, setDemoOpen] = useState(false)

  useEffect(() => {
    document.title = 'Parkko - Gestão Inteligente de Estacionamentos'
  }, [])

  return (
    <div className="min-h-screen bg-background text-foreground font-jakarta selection:bg-primary/20 scroll-smooth">
      <Navbar onOpenDemo={() => setDemoOpen(true)} />

      <main>
        <Hero onOpenDemo={() => setDemoOpen(true)} />
        <YardMapPreview />
        <OperationShowcase />
        <SubscribersPreview />
        <PricingRules />
        <FinancialIntelligence />
        <IntelligentPayments />
        <PricingFAQ onOpenDemo={() => setDemoOpen(true)} />
      </main>

      <Footer onOpenDemo={() => setDemoOpen(true)} />

      <DemoDialog open={demoOpen} onOpenChange={setDemoOpen} />
    </div>
  )
}
